import { SharedApiV2 } from "@capstone/mock-api";
import { PaginatedListQuery } from "src/app/core/request-v2-utils";

export class SiteListQueryModel extends PaginatedListQuery {
  public constructor(args: ClassProperties<SiteListQueryModel>) {
    super(args);
    this.filter = args.filter;
  }

  public readonly filter?: SharedApiV2.SitesFilterDto;

  public serialize(): SharedApiV2.GetSitesQuery {
    return {
      ...this.serializeBase(),
      ...(this.filter === undefined ? {} : { filter: this.filter }),
    };
  }
}
